import { render, staticRenderFns } from "./CoursePresentation.vue?vue&type=template&id=11313a7e&scoped=true&"
import script from "./CoursePresentation.vue?vue&type=script&lang=js&"
export * from "./CoursePresentation.vue?vue&type=script&lang=js&"
import style0 from "./CoursePresentation.vue?vue&type=style&index=0&id=11313a7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11313a7e",
  null
  
)

component.options.__file = "CoursePresentation.vue"
export default component.exports